/**
 * 设备相关接口api（包括通讯设备/虚拟设备）
 */
import Axios from '@/components/api/axios.js'

export default {
	//***************************************************************************************虚拟设备
	//能耗分项设备
	getEnergyDeviceTree: (success, failure) => {
		Axios.post('/virtualDevice/getEnergyDeviceTree.do', {
		}, success, failure)
	},
	//能耗分项类型
	getEnergyType: (success, failure) => {
		Axios.post('/virtualDevice/getEnergyType.do', {
		}, success, failure)
	},
	//获取设备日能耗
	getDayUnitDeviceEnergy: (unitDevices, time, success, failure) => {
		Axios.post('/virtualDevice/getDayUnitDeviceEnergy.do', {
			unitDevices,
			time,
		}, success, failure)
	},
	//获取单位能耗
	getUnitDeviceEnergy: (unitDevices, bgTime, endTime, success, failure) => {
		Axios.post('/virtualDevice/getUnitDeviceEnergy.do', {
			unitDevices,
			bgTime,
			endTime
		}, success, failure)
	},
	//获取变压器信息
	getUnitByqInfo: (unitIds, success, failure) => {
		Axios.post('/virtualDevice/getUnitByqInfo.do', {
			unitIds
		}, success, failure)
	},
	updatePlaceName: (placeId, placeName, success, failure) => {
		Axios.post('/virtualDevice/updatePlaceName.do', {
			placeId,
			placeName
		}, success, failure)
	},
	getEnergyRanking: (unitId, placeId, beginTime, endTime, success, failure) => {
		Axios.post('/history/getEnergyRanking.do', {
			unitId,
			placeId,
			beginTime,
			endTime
		}, success, failure)
	},
	deletePlaceName: (placeId, success, failure) => {
		Axios.post('/virtualDevice/deletePlaceName.do', {
			placeId
		}, success, failure)
	},
	savePlaceName: (unitId, placeName, success, failure) => {
		Axios.post('/virtualDevice/savePlaceName.do', {
			unitId,
			placeName
		}, success, failure)
	},
	getPlaceName: (unitId, placeName, success, failure) => {
		Axios.post('/virtualDevice/getPlaceName.do', {
			unitId,
			placeName
		}, success, failure)
	},
	getHistoryRoomRanking: (unitId, time, success, failure) => {
		Axios.post('/history/getHistoryRoomRanking.do', {
			unitId,
			time
		}, success, failure)
	},
	checkRoomName: (name, success, failure) => {
		Axios.post('/virtualDevice/checkRoomName.do', {
			name
		}, success, failure)
	},
	getDeviceListByUnitId: (unitId, success, failure) => {
		Axios.post('/virtualDevice/getDeviceListByUnitId.do', {
			unitId
		}, success, failure);
	},
	getRoomList: (pageIndex, pageSize, name, placeId, unitId, success, failure) => {
		Axios.post('/virtualDevice/getRoomList.do', {
			pageIndex,
			pageSize,
			name,
			placeId,
			unitId
		}, success, failure)
	},
	deleteByroomId: (id, success, failure) => {
		Axios.post('/virtualDevice/deleteByroomId.do', {
			id
		}, success, failure)
	},
	updateDeviceForRoom: (id, name, placeType, grade, gender, devNos, devWaterNos, success, failure) => {
		Axios.post('/virtualDevice/updateDeviceForRoom.do', {
			id,
			name,
			placeType,
			grade,
			gender,
			devNos,
			devWaterNos
		}, success, failure)
	},
	saveDeviceForRoom: (name, placeId, unitId, devNos, devWaterNos, success, failure) => {
		Axios.post('/virtualDevice/saveDeviceForRoom.do', {
			name,
			placeId,
			unitId,
			devNos,
			devWaterNos
		}, success, failure)
	},
	/**
	 * 获取设备树只有一个应用类型
	 * @param userId
	 * @param appTypeNos
	 * @param success
	 * @param failure
	 */
	getDeviceTreeByappTypeNos: (userId, appTypeNos, success, failure) => {
		Axios.post('/virtualDevice/getDeviceTreeByappTypeNos.do', {
			userId,
			appTypeNos
		}, success, failure)
	},
	/**
	 * 获取可查看的区域设备
	 */
	getAreaDeviceTree: (userId, appTypeNos, success, failure) => {
		Axios.post('/virtualDevice/getAreaDeviceTree.do', {
			userId,
			appTypeNos
		}, success, failure);
	},
	/**
	 * 获取可查看设备树全部
	 */
	getReadDeviceTree: (userId, appTypeNos, success, failure) => {
		Axios.post('/virtualDevice/getReadDeviceTree.do', {
			userId,
			appTypeNos
		}, success, failure);
	},

	/**
	 * 获取可查看设备树全部
	 * @param appType:1：新增业主；xxxx     主要用于判断展示的设备是否已经在电表管理那里添加过了
	 */
	getReadDeviceTreeByAppType: (userId, appTypeNos, appType, success, failure) => {
		Axios.post('/virtualDevice/getReadDeviceTree.do', {
			userId,
			appTypeNos,
			appType
		}, success, failure);
	},

	/**
	 * 通过名字(全称或者一部分)和类型查询单位下所有的组
	 * type为2是配电房
	 */
	getReadableDeviceTreeByTypeProperty(typeProperty, success, failure) {
		Axios.post('/virtualDevice/getReadableDeviceTreeByTypeProperty.do', {
			typeProperty
		}, success, failure)
	},

	/**
	 * 获取可控制设备树
	 * @param {Object} callback
	 */
	getControlDeviceTree: (success, failure) => {
		Axios.post('/virtualDevice/getControlDeviceTree.do', {}, success, failure);
	},
	/**
	 * 查询单位关联的设备列表
	 */
	getDeviceListByDeviceType: (unitId, type, success, failure) => {
		Axios.post('/virtualDevice/getDeviceListByDeviceType.do', {
			unitId,
			type,
		}, success, failure);
	},
	/**
	 * 查询用户可操作设备集合 可查看设备集合
	 * @param {String} userId  用户id
	 */
	getDeviceNosByUserId: (userId, success, failure) => {
		Axios.post('/virtualDevice/getDeviceNosByUserId.do', {
			userId
		}, success, failure)
	},
	/**
	 * 查询单位关联的设备
	 * deviceType   power:能耗 load:负荷
	 */
	getDeviceByUnitIdAndDeviceType: (unitId, deviceType, success, failure) => {
		Axios.post('/virtualDevice/getDeviceByUnitIdAndDeviceType.do', {
			unitId,
			deviceType,
		}, success, failure);
	},
	/**
	 * 获取充电桩树 device/getReadableDeviceTreeByArchTypeCode.do
	 * 充电桩类型 :ChargingPile
	 * 基本变压器:Transformer
	 */
	getReadableDeviceTreeByArchTypeCode: (typeCode, success, failure) => {
		Axios.post('/virtualDevice/getReadableDeviceTreeByArchTypeCode.do', {
			typeCode
		}, success, failure);
	},
	/**
	 * 获取单位下的虚拟设备树 virtualDevice/getVirtualDeviceTreeByUnitId.do
	 * unitId : 单位ID
	 */
	findVirtualDeviceByUnitId: (id, success, failure) => {
		Axios.post('/virtualDevice/findVirtualDeviceByUnitId.do', {
			id
		}, success, failure);
	},
	/**
	 * 通过虚拟设备No查询设备
	 */
	getVirtualDeviceByDeviceNo: (deviceNo, success, failure) => {
		Axios.post('/virtualDevice/getVirtualDeviceByDeviceNo.do', {
			deviceNo
		}, success, failure);
	},
	/**
	 * 通过虚拟设备no查询设备状态，通讯正常/通讯中断/指定时间段有事件产生的为异常
	 */
	getVirtualDeviceStateByDeviceNo: (deviceNos, beginTime, endTime, success, failure) => {
		Axios.post('/virtualDevice/getVirtualDeviceStateByDeviceNo.do', {
			deviceNos,
			beginTime,
			endTime,
		}, success, failure);
	},
	/**
	 * 获取单位下的虚拟设备组树
	 * @param {String} unitId = [单位id] 
	 */
	getVirtualDeviceTreeByUnitId: (unitId, success, failure) => {
		Axios.post('/virtualDevice/getVirtualDeviceTreeByUnitId.do', {
			unitId
		}, success, failure);
	},
	//***************************************************************************************通讯设备
	/**
	 * 添加通讯设备
	 * @param {String} name = [设备名称] 
	 * @param {String} deviceGroup = [设备模板组名称] 
	 * @param {String} deviceTemplate = [设备模板名称] 
	 * @param {String} deviceSubseries = [设备子系列名称] 
	 * @param {String} channelNo = [设备对应通道no：不指定的话，接口会查询当前连接采集平台对应的通道no]
	 * @param {String} groupNo = [虚拟设备组no：不指定的话，接口就不会给添加的通讯设备添加对应的虚拟设备]
	 */
	addDevice: (name, deviceGroup, deviceTemplate, deviceSubseries, channelNo, groupNo, success, failure) => {
		Axios.post('/device/addDevice.do', {
			name,
			deviceGroup,
			deviceTemplate,
			deviceSubseries,
			channelNo,
			groupNo,
		}, success, failure);
	},
	/**
	 * 删除通讯设备及其变量
	 * @param {String} no = [设备no] 
	 * @param {String} parentarea = [设备parentarea] 
	 */
	deleteDevice: (no, parentarea, success, failure) => {
		Axios.post('/device/deleteDevice.do', {
			no,
			parentarea,
		}, success, failure);
	},
	/**
	 * 查询虚拟设备来源的通信设备列表
	 */
	findByVirtualDeviceNo: (no, success, failure) => {
		Axios.post('/device/findByVirtualDeviceNo.do', {
			no,
		}, success, failure);
	},
	// 获取通道设备树
	getChannelAndDeviceTree: (success, failure) => {
		Axios.post('/device/getChannelAndDeviceTree.do', {

		}, success, failure)
	},
	// 获取虚拟设备树
	getChannelAndVirtualDeviceTree: (success, failure) => {
		Axios.post('/virtualDevice/getDeviceTree.do', {

		}, success, failure)
	},
	/**
	 * 添加或更新虚拟设备组
	 * @param {String}  no 否
	 * @param {String}  name 是
	 * @param {String}  fatherno 是
	 * @param {String}  unitId 是
	 * @param {String}  sort 是
	 * @param {String}  devicetype 否    暂时不了解字段用法，可默认为0
	 */
	saveAppClassType: (no, name, fatherno, unitId, sort, devicetype, success, failure) => {
		Axios.post('/virtualDevice/saveAppClassType.do', {
			no,
			name,
			fatherno,
			unitId,
			sort,
			devicetype
		}, success, failure)
	},
	/**
	 * 删除组
	 */
	deleteAppClassType: (no, success, failure) => {
		Axios.post('/virtualDevice/deleteAppClassType.do', {
			no
		}, success, failure)
	},
	/**
	 * 添加虚拟设备
	 * @param {String}  no  否 
	 * @param {String}  name  是  虚拟设备名称
	 * @param {String}  groupNo  是  虚拟设备组no
	 * @param {String}  generallyNo  否  通讯设备no，填写此参数后会复制当前通讯变量为虚拟变量
	 * @param {String}  parentarea  否  通讯设备parentarea
	 */
	saveVirtualDevice: (no, name, groupNo, generallyNo, parentarea, success, failure) => {
		Axios.post('/virtualDevice/saveVirtualDevice.do', {
			no,
			name,
			groupNo,
			generallyNo,
			parentarea
		}, success, failure)
	},
	/**
	 * 删除虚拟设备
	 */
	deleteVirtualDevice: (no, success, failure) => {
		Axios.post('/virtualDevice/deleteVirtualDevice.do', {
			no
		}, success, failure)
	},
	/**
	 * 根据设备获取单位信息
	 */
	getUnitByVirtualDeviceNo: (deviceNo, success, failure) => {
		Axios.post('virtualDevice/getUnitByVirtualDeviceNo.do', {
			deviceNo
		}, success, failure)
	},
	/**
	 * 平衡分析接口
	 */
	getAreaDeviceEnergy: (dayType, appTypeNos, startTime, endTime, success, failure) => {
		Axios.post('/virtualDevice/getAreaDeviceEnergy.do', {
			dayType,
			appTypeNos,
			startTime,
			endTime
		}, success, failure)
	},
	/**
	* 树形分析接口
	*/
	getReadClassTypeTree: (userld, appTypeNos, success, failure) => {
		Axios.post('/virtualDevice/getReadClassTypeTree.do', {
			userld,
			appTypeNos
		}, success, failure)
	},
	/**
   * 展示页面接口
   */
	getEnergyLossList: (chartId, type, startTime, endTime, success, failure) => {
		//Axios.post('/history/getEnergyLossList.do', {
		Axios.post('/energy/getEnergyFlowLossList.do', {
			chartId, type, startTime, endTime,
		}, success, failure)
	},
	//树形获取设备接口
	getReadDeviceByNo: (no, appTypeNos, success, failure) => {
		Axios.post('/virtualDevice/getReadDeviceByNo.do', {
			no,
			appTypeNos
		}, success, failure)
	},
	//获取配置表格数据
	getEnergyLossSetList: (unitId, success, failure) => {
		Axios.post('/history/getEnergyLossSetList.do', {
			unitId
		}, success, failure)
	},
	//删除接口
	deleteEnergyLossSet: (id, success, failure) => {
		Axios.post('/history/deleteEnergyLossSet.do', {
			id
		}, success, failure)
	},
	//创建 * 修改接口 ，创建不用传ID,修改带ID
	saveEnergyLossSetInfo: (id, setName, unitId, enterLine, outLine, success, failure) => {
		Axios.post('/history/saveEnergyLossSetInfo.do', {
			id,
			setName,
			unitId,
			enterLine,
			outLine
		}, success, failure)
	},
	//能耗排名
	getUnitBoardRanking: (typeCode, startTime, endTime, dayType, searchType, success, failure) => {
		Axios.post('/entity/getUnitBoardRanking.do', {
			typeCode,
			startTime,
			endTime,
			dayType,
			searchType
		}, success, failure)
	},
	 //获取设备信息
	getDeviceInfoByStockNo: (stockNo,success,failure) => {
	  	Axios.post('/deviceScanCode/getDeviceInfoByStockNo', {
	  		stockNo
		},success,failure)
	},
	// 工程设备扫描列表
	getDeviceScanCodeList: (pageIndex, pageSize, startTime, endTime, success, failure) => {
		Axios.post('/deviceScanCode/getLimitList', {
			pageIndex,
			pageSize,
			startTime,
			endTime
		}, success, failure)
	},
	// 保存工程设备扫描
	saveDeviceScanCode: (deviceScanCode, success, failure) => {
		Axios.post('/deviceScanCode/save',
			deviceScanCode,
			success,
			failure
		)
	},
	// 更新工程设备扫描相关文件
	updFilePath: (deviceScanCode, success, failure) => {
		Axios.post('deviceScanCode/updFilePath',
			deviceScanCode,
			success,
			failure
		)
	},
	// 导出工程设备扫描数据
	exportExcel: (ids, success, failure) => {
		Axios.post('deviceScanCode/exportExcel', {
			ids
		}, success, failure)
	},
	// 删除工程设备扫描数据
	deleteDeviceScanCode: (ids, success, failure) => {
		Axios.post('deviceScanCode/delete', {
			ids
		}, success, failure)
	},
	// 获取文件地址
	getPathByStockNoAndFilename: (stockNo, filename, success, failure) => {
		Axios.post('deviceScanCode/getPathByStockNoAndFilename', {
			stockNo,
			filename
		}, success, failure)
	},
	// 上传Excel
	uploadExcel: (formData, success, failure) => {
		Axios.post('deviceScanCode/uploadExcel',
			formData,
			success, failure)
	},
	//德茵左侧看板数据
	getKanbanRtValue: (success, failure) => {
		Axios.get('manualInputVariable/getKanbanRtValue',
			success, failure)
	},
	//德茵右侧监测看板数据
	getKanbanEnergyMonitoring: (success, failure) => {
		Axios.get('manualInputVariable/getKanbanEnergyMonitoring',
			success, failure)
	},
	//德茵右侧柱形图看板数据
	getColumnBarList: (success, failure) => {
		Axios.get('manualInputVariable/getColumnBarList',
			success, failure)
	},
	//德茵右侧饼状图看板数据
	getRoundBarList: (interval, success, failure) => {
		Axios.get('manualInputVariable/getRoundBarList',
			{ interval },
			success, failure)
	}
}